import { RaidSimUI } from './raid_sim_ui.js';

const ui = new RaidSimUI(document.body, {});
